<template>
    <div>
        <slot name="prepend"/>
        <div class="form__split form__split-border">
            <div class="form__split-title">
                <div class="h3">Укажите паспортные данные</div>
            </div>
            <div class="form__split-fields">
                <div class="form__row">
                    <div class="form__col">
                        <DInput
                            v-model.trim="v$.passportSerial.$model"
                            label="Серия"
                            name="passportSerial"
                            :error="v$.passportSerial.$error"
                            type="text"
                            v-mask="'## ##'"
                        >
                            <template #messages v-if="v$.passportSerial.$error">
                                <p v-if="v$.passportSerial.$error && v$.passportSerial.required?.$invalid">Это поле необходимо заполнить</p>
                                <p v-if="v$.passportSerial.$error && v$.passportSerial.passportSerNum?.$invalid">Неверный формат</p>
                            </template>
                        </DInput>
                    </div>
                    <div class="form__col">
                        <DInput
                            v-model.trim="v$.passportNumber.$model"
                            label="Номер"
                            name="passportNumber"
                            :error="v$.passportNumber.$error"
                            type="text"
                            v-mask="'######'"
                        >
                            <template #messages v-if="v$.passportNumber.$error">
                                <p v-if="v$.passportNumber.$error && v$.passportNumber.required?.$invalid">Это поле необходимо заполнить</p>
                                <p v-if="v$.passportNumber.$error && v$.passportNumber.passportNum?.$invalid">Неверный формат</p>
                            </template>
                        </DInput>
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__col form__col_1-1">
                        <ui-form-field
                            label="Кем выдан"
                            :value="v$.passportIssueBy.$model"
                            :errors="vuelidateErrorMesages.passportIssueBy"
                            id="passport-issue-by"
                        >
                            <template v-slot:default="{ id, errors }">
                                <UiTextInputSuggestions
                                    :id="id"
                                    v-model="v$.passportIssueBy.$model"
                                    :suggestionType="ESuggestionTypes.FMS_UNIT"
                                    :count="3"
                                    :error="!!errors.length"
                                    name="passport-issue-by"
                                    @update:data="v$.passportCode.$model = $event.code"
                                />
                            </template>
                        </ui-form-field>
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__col">
                        <ui-form-field
                            label="Дата выдачи"
                            :errors="v$.passportIssueDate.$error && !v$.passportIssueDate.required ? [{ key: 'passportIssueDate', title: 'Это поле необходимо заполнить'}] : []"
                            id="passportIssueDate"
                            :value="v$.passportIssueDate.$model"
                        >
                            <template v-slot:default="{ id, errors }">
                                <Ui-Date-Picker
                                    :id="id"
                                    name="passportIssueDate"
                                    :error="errors.length > 0"
                                    :model-value="v$.passportIssueDate.$model"
                                    @update:model-value="v$.passportIssueDate.$model = fixFormatDate($event)"
                                ></Ui-Date-Picker>
                            </template>
                        </ui-form-field>
                    </div>
                    <div class="form__col">
                        <DInput
                            v-model.trim="v$.passportCode.$model"
                            label="Код подразделения"
                            name="passportCode"
                            :error="v$.passportCode.$error"
                            type="text"
                            v-mask="'###-###'"
                        >
                            <template #messages v-if="v$.passportCode.$error">
                                <p v-if="v$.passportCode.$error && v$.passportCode.required?.$invalid">Это поле необходимо заполнить</p>
                                <p v-if="v$.passportCode.$error && v$.passportCode.passportCode?.$invalid">Неверный формат</p>
                            </template>
                        </DInput>
                    </div>
                </div>
                <div class="form__row _mb-0">
                    <div class="form__col form__col_1-1">
                        <ui-form-field
                            label="Место рождения"
                            :value="v$.passportBirthPlace.$model"
                            :errors="vuelidateErrorMesages.passportBirthPlace"
                            id="passport-birth-place"
                        >
                            <template v-slot:default="{ id, errors }">
                                <UiTextInputSuggestions
                                    :id="id"
                                    v-model="v$.passportBirthPlace.$model"
                                    :suggestionType="ESuggestionTypes.ADDRESS"
                                    :count="3"
                                    :error="!!errors.length"
                                    name="passport-birth-place"
                                />
                            </template>
                        </ui-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="form__split form__split-nopb">
            <div class="form__split-title">
                <div class="h3">Укажите адрес регистрации</div>
            </div>
            <div class="form__split-fields">
                <div class="form__row">
                    <div class="form__col">
                        <ui-form-field
                            label="Дата регистрации"
                            :errors="v$.registrationDate.$error && !v$.registrationDate.required ? [{ key: 'registrationDate', title: 'Это поле необходимо заполнить'}] : []"
                            id="registrationDate"
                            :value="v$.registrationDate.$model"
                        >
                            <template v-slot:default="{ id, errors }">
                                <Ui-Date-Picker
                                    :id="id"
                                    name="registrationDate"
                                    :error="errors.length > 0"
                                    :model-value="v$.registrationDate.$model"
                                    @update:model-value="v$.registrationDate.$model = fixFormatDate($event)"
                                ></Ui-Date-Picker>
                            </template>
                        </ui-form-field>
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__col form__col_1-1">
                        <ui-form-field
                            label="Адрес"
                            :value="v$.registrationAddress.$model"
                            :errors="vuelidateErrorMesages.registrationAddress"
                            id="registration-address"
                        >
                            <template v-slot:default="{ id, errors }">
                                <UiTextInputSuggestions
                                    :id="id"
                                    v-model="v$.registrationAddress.$model"
                                    :suggestionType="ESuggestionTypes.ADDRESS"
                                    :count="3"
                                    :error="!!errors.length"
                                    name="registration-address"
                                />
                            </template>
                        </ui-form-field>
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__col _dflex form__col_1-1">
                        <DCheckbox v-model="addressIsSame">
                            <p class="p2">Адрес регистрации совпадает с фактическим адресом</p>
                        </DCheckbox>
                    </div>
                </div>
                <div
                    v-if="!addressIsSame"
                    class="form__row"
                >
                    <div class="form__col form__col_1-1">
                        <ui-form-field
                            label="Адрес проживания"
                            :value="v$.livingAddress.$model"
                            :errors="vuelidateErrorMesages.livingAddress"
                            id="living-address"
                        >
                            <template v-slot:default="{ id, errors }">
                                <UiTextInputSuggestions
                                    :id="id"
                                    v-model="v$.livingAddress.$model"
                                    :suggestionType="ESuggestionTypes.ADDRESS"
                                    :count="3"
                                    :error="!!errors.length"
                                    name="living-address"
                                />
                            </template>
                        </ui-form-field>
                    </div>
                </div>

                <div class="form__group">
                    <DButton @click="sendForm" id="ym-deposit-step2" :disabled="!stepThreeComplete">Продолжить</DButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import useVuelidate from "@vuelidate/core"
import { required, requiredIf } from '@vuelidate/validators';
import {
    passportSerNum, passportNum, passportIssueBy as passportIssueByV,
    passportCode as passportCodeV,
} from '../../assets/js/vue/validations';
import dateMixin from '../../assets/js/vue/mixins/dateMixin';
import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';
import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
import vuelidateMessages from '../../assets/js/vue/validationsMessages';
import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
import { DCheckbox } from '@ahml/domrfbank-ui/elements/DCheckbox';
import { DInput } from '@ahml/domrfbank-ui/elements/DInput';

export default {
    name: 'CardsFormV2Step3',
    mixins: [dateMixin],
    components: {
        UiTextInputSuggestions,
        DButton,
        DCheckbox,
        DInput
    },
    props: {
        endpoint: {
            type: String,
            require: true
        }
    },
	setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            passportSerial: '',
            passportNumber: '',
            passportIssueBy: '',
            passportIssueDate: '',
            passportCode: '',
            passportBirthPlace: '',
            registrationAddress: '',
            registrationDate: '',
            livingAddress: '',
            addressIsSame: true,
            stepThreeComplete: false,
            ESuggestionTypes,
        };
    },
    computed: {
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.v$).activeErrorMessages;
        },
        formData() {
            let data = {
                data: {
                    type: "debitCard",
                    attributes: {
                        passportNumber: this.passportNumber,
                        passportCode: this.passportCode,
                        passportSerial: this.passportSerial.replace(/\s/g, ''),
                        passportIssueBy: this.passportIssueBy,
                        passportIssueDate: this.passportIssueDate,
                        passportBirthPlace: this.passportBirthPlace,
                        registrationAddress: this.registrationAddress,
                        registrationDate: this.registrationDate,
                        livingAddress: this.livingAddress
                    }
                }
            }

            return data;
        }
    },
    watch: {
        passportSerial() {
            this.stepThreeCompleteCheck();
        },
        passportNumber() {
            this.stepThreeCompleteCheck();
        },
        passportIssueBy() {
            this.stepThreeCompleteCheck();
        },
        passportIssueDate() {
            this.stepThreeCompleteCheck();
        },
        passportCode() {
            this.stepThreeCompleteCheck();
        },
        passportBirthPlace() {
            this.stepThreeCompleteCheck();
        },
        registrationAddress() {
            this.stepThreeCompleteCheck();
        },
        livingAddress() {
            this.stepThreeCompleteCheck();
        },
        registrationDate() {
            this.stepThreeCompleteCheck();
        },
        addressIsSame: {
            immediate: true,
            handler() {
                this.livingAddress = '';
            },
        },
    },
    validations() {
        return {
            passportSerial: { required, passportSerNum },
            passportNumber: { required, passportNum },
            passportIssueBy: { required, passportIssueBy: passportIssueByV },
            passportIssueDate: { required },
            passportCode: { required, passportCode: passportCodeV },
            passportBirthPlace: { required },
            registrationAddress: { required },
            registrationDate: { required },
            livingAddress: { required: requiredIf(!this.addressIsSame) },
        };
    },
    methods: {
        stepThreeCompleteCheck() {
            if (!this.v$.passportSerial.$invalid &&
                !this.v$.passportNumber.$invalid &&
                !this.v$.passportIssueBy.$invalid &&
                !this.v$.passportIssueDate.$invalid &&
                !this.v$.passportCode.$invalid &&
                !this.v$.passportBirthPlace.$invalid &&
                !this.v$.registrationAddress.$invalid &&
                !this.v$.registrationDate.$invalid &&
                !this.v$.livingAddress.$invalid
            ) {
                this.stepThreeComplete = true;
            } else {
                this.stepThreeComplete = false;
            }
        },
        sendForm() {
            this.v$.passportSerial.$touch();
            this.v$.passportNumber.$touch();
            this.v$.passportIssueBy.$touch();
            this.v$.passportIssueDate.$touch();
            this.v$.passportCode.$touch();
            this.v$.passportBirthPlace.$touch();
            this.v$.registrationAddress.$touch();
            this.v$.registrationDate.$touch();
            this.v$.livingAddress.$touch();

            if (
                !this.v$.passportSerial.$invalid &&
                !this.v$.passportNumber.$invalid &&
                !this.v$.passportIssueBy.$invalid &&
                !this.v$.passportIssueDate.$invalid &&
                !this.v$.passportCode.$invalid &&
                !this.v$.passportBirthPlace.$invalid &&
                !this.v$.registrationAddress.$invalid &&
                !this.v$.registrationDate.$invalid &&
                !this.v$.livingAddress.$invalid
            ) {
                this.$emit('sendStep', this.formData, 3);
            }
        },
    },
};
</script>
